export default "__VITE_ASSET__SdKh$A7S__"